import React from "react";
import AccessDenied from "../Permissions/";

const TAB_TO_PERMISSIONS_MAP: { [index: string]: string } = {
  add: "retailer_reporting_access",
  analytics: "access_marketplace_dashboard",
  storeVisits: "store_visits_access",
  admin: "retailer_reporting_access"
};

const merchantPermissionCheck = (merchants: any, merchant_id: string) => {
  if (typeof merchants == "object" && merchant_id)
    return merchants.indexOf(parseInt(merchant_id)) != -1;
  if (typeof merchants == "boolean" || typeof merchants == "object")
    return merchants;
  else return false;
};

const getMerchantLength = (merchants: any) => {
  if (typeof merchants == "object") return merchants.length;
  else return "unknown";
};

const adminCheck = (permissions: any) => {
  let _admin = permissions["Admin"];
  if (typeof _admin == "object") {
    return false;
  } else {
    return _admin;
  }
};

const parseRequestedTab = (path: string) => {
  if (/\/merchants/.test(path)) return "add";

  if (/\/analytics/.test(path)) return "analytics";

  if (/\/store-visits/.test(path)) return "storeVisits";

  if (/\/admin/.test(path)) return "admin";
};

const getTabPermission = (tab: string, permissions: any) => {
  return permissions[TAB_TO_PERMISSIONS_MAP[tab]];
};

const authorizeADD = (
  routerProps: any,
  permission: any,
  component: JSX.Element
) => {
  const merchants = permission.Merchant;
  const merchantId = routerProps.match.params.merchant_id;
  const canAccessMerchant = merchantPermissionCheck(merchants, merchantId);

  // Set merchant ID in URL if user only has access to one.
  if (
    getMerchantLength(merchants) == 1 &&
    routerProps.match.path == "/merchants"
  ) {
    location.href = `/merchants/${merchants[0]}`;
    return null;
  }

  return canAccessMerchant ? component : <AccessDenied />;
};

const authorizeDashboard =
  (prefix: string) =>
  (routerProps: any, permission: any, component: JSX.Element) => {
    const merchants = permission.Merchant;
    let merchantId = null;
    if (/merchant=(\d*)/.test(routerProps.location.search))
      merchantId = routerProps.location.search.match(/merchant=(\d*)/)[1];

    const canAccessMerchant = merchantPermissionCheck(merchants, merchantId);

    // Set merchant ID in URL if user only has access to one.
    if (
      getMerchantLength(merchants) == 1 &&
      routerProps.location.search.indexOf("merchant") == -1
    ) {
      location.href = `/${prefix}?merchant=${merchants[0]}`;
      return null;
    }

    return canAccessMerchant ? component : <AccessDenied />;
  };

const authorizeAdmin = (
  routerProps: any,
  permission: any,
  component: JSX.Element
) => (adminCheck(permission) ? component : <AccessDenied />);

const tabAuthorizations: { [index: string]: (r: any, p: any, c: any) => any } =
  {
    add: authorizeADD,
    analytics: authorizeDashboard("analytics"),
    storeVisits: authorizeDashboard("store-visits"),
    admin: authorizeAdmin
  };

interface AuthorizationProps {
  routerProps: any;
  permissions: any;
  children?: JSX.Element;
}

// HOC that handles whether or not the user is allowed to see the page.
const Authorization = (props: AuthorizationProps) => {
  const { params, path } = props.routerProps.match;
  const requestedTab = parseRequestedTab(path);
  const permission = getTabPermission(requestedTab, props.permissions);

  if (!permission) return <AccessDenied />;

  // Regardless of the specific permission, if the user is an Admin we grant access
  if (adminCheck(permission)) return props.children;

  // Perform authorization unique to the requested page.
  return tabAuthorizations[requestedTab](
    props.routerProps,
    permission,
    props.children
  );
};

export default Authorization;



// WEBPACK FOOTER //
// ./client/modules/common/components/Authorization/index.tsx